/*
Main menu
*/
import {
    SET_LOADING,
} from '../mutation-types';
import axios from 'axios';

export default {
    /**
     * States
     */
    state: {
        menu: null,
    },

    /**
     * Mutations
     */
    mutations: {
        setMenu(state, payload) {
            state.menu = payload;
        },
    },

    /**
     * Getters
     */
    getters: {
        menu: state => state.menu,
    },

    /**
     * Actions
     */
    actions: {
        fetchMenu({ commit }, payload) {
            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    commit('setMenu', response.data);
                })
                .catch((error) => {
                    // commit(SET_ERROR, error.response);
                    // commit(SET_LOADING, false);
                    // console.log('STORE error fetching menu: ', this.getters.loading, this.getters.error);
                });
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js